import { HeartIcon } from "lucide-react";

export default function Footer() {
    return (
        <div className="text-sm font-mono flex justify-center items-center">
            Made with <HeartIcon className="w-4 h-4 mx-2 text-destructive fill-destructive" /> by Rizkal
        </div>
    );
}
